'use strict';

// Allineata a notifyMe / form Lavazza lato client.
const EMAIL_PATTERN = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/i;
const DEFAULT_INVALID = 'Please enter a valid email address.';
const LOGIN_FORMAT_ERROR_DELAY_MS = 1000;

function findEmailField(root) {
	return root.querySelector('input[data-gigya-name="loginID"]')
		|| root.querySelector('#gigya-textbox-loginID')
		|| root.querySelector('.email-wrapper input')
		|| root.querySelector('.gigya-composite-control-loginID input')
		|| root.querySelector('input[name="loginID"]')
		|| root.querySelector('input[name="username"]')
		|| root.querySelector('input[name="email"]')
		|| root.querySelector('input[type="email"]');
}

function shouldValidateEmailFormat(root, screenId) {
	const screen = String(screenId || '').toLowerCase();

	if (screen.indexOf('forgot-password') !== -1 || screen.indexOf('login') !== -1) {
		return true;
	}

	return !!root.querySelector('#gigya-forgot-password-screen, #gigya-login-screen, #gigya-checkout-login-screen');
}

function isLoginScreen(root, screenId) {
	const screen = String(screenId || '').toLowerCase();

	if (screen.indexOf('login') !== -1) {
		return true;
	}

	return !!root.querySelector('#gigya-login-screen, #gigya-checkout-login-screen');
}

function getInvalidMessage(campo) {
	return campo.getAttribute('data-lvz-email-error')
		|| campo.getAttribute('data-error-invalid')
		|| DEFAULT_INVALID;
}

function ensureErrorEl(campo) {
	const control = campo.closest('.gigya-composite-control') || campo.parentNode;
	let errorEl = control.querySelector('.lvz-gigya-email-error');

	if (errorEl) {
		return errorEl;
	}

	errorEl = document.createElement('span');
	errorEl.className = 'lvz-gigya-email-error';
	errorEl.setAttribute('role', 'alert');
	errorEl.setAttribute('aria-live', 'polite');

	// Dopo il messaggio Gigya nativo, cosi' non viene sovrascritto da Gigya.
	const gigyaMsg = control.querySelector('.gigya-error-msg');
	if (gigyaMsg && gigyaMsg.parentNode) {
		gigyaMsg.parentNode.insertBefore(errorEl, gigyaMsg.nextSibling);
	} else if (campo.parentNode) {
		campo.parentNode.insertBefore(errorEl, campo.nextSibling);
	} else {
		control.appendChild(errorEl);
	}

	return errorEl;
}

function emailValidation(root, currentScreen) {
	if (!root) {
		return null;
	}

	if (!shouldValidateEmailFormat(root, currentScreen)) {
		return null;
	}

	const campo = findEmailField(root);
	if (!campo) {
		return null;
	}

	if (campo.getAttribute('data-lvz-email-bound') === '1') {
		return campo._lvzEmailValidation || null;
	}
	campo.setAttribute('data-lvz-email-bound', '1');

	let toccato = false;
	let formatErrorTimer = null;
	const pauseBeforeError = isLoginScreen(root, currentScreen);
	const errorEl = ensureErrorEl(campo);

	function clearError() {
		errorEl.textContent = '';
		errorEl.classList.remove('is-visible');

		// Non togliere gigya-error se Gigya sta mostrando il required.
		const gigyaMsg = (campo.closest('.gigya-composite-control') || campo.parentNode)
			.querySelector('.gigya-error-msg');
		const gigyaHasMsg = gigyaMsg && String(gigyaMsg.textContent || '').trim();

		if (!gigyaHasMsg) {
			campo.classList.remove('gigya-error');
			campo.removeAttribute('aria-invalid');
		}
	}

	function showFormatError(message) {
		campo.classList.remove('gigya-valid');
		campo.classList.add('gigya-error');
		campo.setAttribute('aria-invalid', 'true');
		errorEl.textContent = message;
		errorEl.classList.add('is-visible');
	}

	function getFormatError(value) {
		// Vuoto: lascia il required a Gigya.
		if (!value) {
			return null;
		}

		if (!EMAIL_PATTERN.test(value)) {
			return getInvalidMessage(campo);
		}

		return null;
	}

	function aggiorna() {
		if (!toccato) {
			return;
		}

		const errore = getFormatError((campo.value || '').trim());
		if (errore) {
			showFormatError(errore);
		} else {
			clearError();
		}
	}

	function isValid() {
		// true se vuoto (Gigya gestisce required) o formato ok
		return !getFormatError((campo.value || '').trim());
	}

	function clearFormatErrorTimer() {
		if (formatErrorTimer) {
			window.clearTimeout(formatErrorTimer);
			formatErrorTimer = null;
		}
	}

	function markTouched() {
		toccato = true;
		clearFormatErrorTimer();
		aggiorna();
	}

	campo.addEventListener('input', function () {
		toccato = true;

		if (!pauseBeforeError) {
			aggiorna();
			return;
		}

		clearError();
		clearFormatErrorTimer();
		formatErrorTimer = window.setTimeout(aggiorna, LOGIN_FORMAT_ERROR_DELAY_MS);
	});
	campo.addEventListener('blur', function () {
		toccato = true;
		clearFormatErrorTimer();
		aggiorna();
	});

	const api = {
		isValid: isValid,
		markTouched: markTouched
	};
	campo._lvzEmailValidation = api;
	return api;
}

module.exports = emailValidation;
